import { useTRPC } from "../trpc/client";
import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "./useMerchant";

export function useFetchUser() {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const { data, isPending, refetch } = useQuery({
    ...trpc.users.get.queryOptions(undefined),
    enabled: !!merchant?.id,
  });

  return { user: data, isLoading: isPending, refetch };
}
